/**
 * What every draw of a particle emitter's instances shares: the colour attribute and the draw a
 * material reads (`material.cpp:1260-1351`). The vertex stage itself is `godotParticlesProgram.ts`,
 * and the billboard every instanced draw shares is `surfaceBillboard.ts`.
 */
import { surfaceBillboard, } from '../../resources/materials/standardmaterial3d/materialBag';
import { PARTICLES_ANIM_DEFAULTS, } from '../../resources/materials/standardmaterial3d/types';
/** The instanced attribute that holds each particle's colour, the buffer's floats 12 to 15. */
export const PARTICLE_COLOR_ATTRIBUTE = 'particleColor';
/** The particle draw of `scalars`, or Godot's default surface for none. */
export function particleDrawOf(scalars) {
    return { billboard: surfaceBillboard(scalars), anim: scalars?.particlesAnim ?? PARTICLES_ANIM_DEFAULTS };
}
//# sourceMappingURL=godotParticles.js.map